<template>
  <v-footer v-bind="localAttrs" :padless="true">
   
    <v-card flat tile width="100%" color="#393938" class="lighten-1 text-center mx-auto">
      <v-card-text>
        <v-row align="center">
          <v-col
            v-for="(link, i) in buttons"
            :key="i"
            v-bind="link"
            lg="2"
            md="4"
            sm="12"
            cols="12"
            align="center text-align-center"
          >
            <v-btn text @click="onClick($event, link)">
              <v-img
                max-height="65px"
                max-width="65px"
                :src="require(`@/assets/Footer/${link.img}.png`)"
              ></v-img>
              <b class="white--text text-right">{{ link.text }}</b>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
     <v-card flat tile width="100%"  class="lighten-1 text-center mx-auto">
      <v-card-text>
    <v-row>
      <v-col lg="4" xl="4" md="4" sm="12" xs="12" cols="12">
        <!-- <v-container> -->
          <v-img width="100%" src="@/assets/Footer/computador.png"></v-img>
        <!-- </v-container> -->
      </v-col>
      <v-col lg="4" xl="4" md="4" sm="12" xs="12" cols="12" class="text-center">
        <v-btn
          v-for="(link, i) in items"
          :key="i"
          v-bind="link"
          text
          fab
          x-large
          @click="$router.open(link)"
        >
          <v-img max-width="50%" :src="require(`@/assets/Footer/${link.img}.png`)"></v-img>
        </v-btn>
        <br />
        <v-divider></v-divider>
        <br />
        <v-img width="100%"  src="@/assets/Footer/logo_fundacion_pcshek.png"></v-img>
        <v-card-text class="text-center">
          <strong>COPYRIGHT © PCSHEK 2020 - Todos los derechos reservados</strong>
        </v-card-text>
      </v-col>
      <v-col lg="4" xl="4" md="4" sm="12" xs="12" cols="12" class="text-center">
        <!-- <v-card-text > -->
          <v-row v-for="(link, i) in contact" :key="i" v-bind="link"  >
            <v-col cols="8" class="box">
              
                <p class="font-weight-black text-center" >{{link.text}}</p>
              
              
            </v-col>
            <v-col cols="4">
              <v-img max-width="60%" :src="require(`@/assets/Footer/${link.icon}.png`)"></v-img>
            </v-col>
          </v-row>
        <!-- </v-card-text> -->
      </v-col>
    </v-row>
    </v-card-text>
    </v-card>

    <!-- Load Facebook SDK for JavaScript -->
      
  </v-footer>
</template>

<script>

export default {
  name: "CoreFooter",

  data: () => ({
    items: [
      {
        href: "https://www.facebook.com/fundacion.pcshek.col/",
        img: "facebook"
      },
      {
        href: "https://www.linkedin.com/in/fundaci%C3%B3n-pcshek-3ba5041b1/",
        img: "twitter"
      },
      {
        href: "https://www.instagram.com/fundacionpcshekcol/",
        img: "instagram"
      }
    ],
    buttons: [
      {
        text: "Nosotros",
        href: "/nosotros",
        img: "nosotros"
      },
      {
        text: "Cómo lo hacemos",
        href: "/comolohacemos",
        img: "como_lo_hacemos"
      },
      {
        text: "Proyecto",
        href: "/proyectos",
        img: "proyectos"
      },
      {
        text: "Donaciones",
        href: "/donaciones",
        img: "donaciones"
      },
      {
        text: "Museo",
        href: "/museo",
        img: "museo"
      },
      {
        text: "Contacto",
        href: "/contacto",
        img: "contacto"
      }
    ],
    contact: [
      { icon: "correo", text: "info@fundacionpcshek.com" },
      { icon: "telefono", text: "318 6890437 - 310 4856619" },
      { icon: "direccion", text: "Bogotá, Colombia." }
    ],
    localAttrs: ""
  }),
  // mounted(){
  //   window.fbAsyncInit = function() {
  //         this.FB.init({
  //           xfbml            : true,
  //           version          : 'v7.0'
  //         });
  //       };
  // },
  // created(){
  //   (function(d, s, id) {
  //       var js, fjs = d.getElementsByTagName(s)[0];
  //       if (d.getElementById(id)) return;
  //       js = d.createElement(s); js.id = id;
  //       js.src = 'https://connect.facebook.net/es_LA/sdk/xfbml.customerchat.js';
  //       fjs.parentNode.insertBefore(js, fjs);
  //     }(document, 'script', 'facebook-jssdk'));
  // },
  methods: {


    onClick(e, item) {
      e.stopPropagation();
      this.$router.push(item.href);
      if (!item.href) return;
      // this.$vuetify.goTo(item.href.endsWith("!") ? 0 : item.href);
    },
    getImgUrl(item) {
      console.log(item.img);
      return require(item.img);
    }
  }
};
</script>
<style scoped>
.box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.floatcenter {
  display: flex;
  display: -webkit-flex;
  margin: auto;
}
</style>
